<template>
    <div class="relative overflow-hidden font-ww-medium">
      <nuxt-img
          class="h-controller block w-full h-full object-cover lg:relative inset-0 filter brightness-75"
          width="1920"
          height="787"
          loading="lazy"
          format="webp"
          sizes="xs:320px sm:440px md:768px lg:1024px xl:1200px 2xl:1920px"
          :alt="imageAlt"
          :src="imageSrc"
      />
    </div>

</template>

<script setup>
const props = defineProps({
  imageSrc: {
    type: String,
    default: 'assets/images/bnr-3.jpg'
  },
  imageAlt: {
    type: String,
    default: 'Descriptive Alt Text'
  }
});

defineBuilderComponent({
    friendlyName: "Background Image",
    inputs: [
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "assets/images/bnr-3.jpg"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "Descriptive Alt Text"
        }
    ]
});
</script>

<style>

@media (max-width: 767px) {
  .h-controller {
    max-height: 80rem !important;;
  }
}
@media (min-width: 768px) and (max-width: 1079px) {
  .h-controller {
    max-height:  80rem !important;;
  }
}

@media (min-width: 1080px) {
  .h-controller {
    max-height:  80rem !important;;
  }
}

.height-70vh {
  height:70vh;
}
</style>